import classNames from "classnames";
import * as Moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { DragSource, DropTarget } from "react-dnd";
import { Link } from "react-router-dom/es";
import momentLocalizer from "react-widgets-moment";
import DateTimePicker from "react-widgets/lib/DateTimePicker";
import "react-widgets/lib/scss/react-widgets.scss";
import { ContentTypeIcon } from "..";
import { Box } from "../layout";
import { Icon, Switch } from "../widgets";
import "./styles.scss";
import { API_ROOT, APP_ROOT } from "signoxe/constants/config";

momentLocalizer();

class PlaylistItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showloading: this.props.item.item,
      thumbnails: this.props.thumbnails,
      duration: props.item.duration,
      startTime: props.item.start_time,
      expireOn: props.item.expire_on,
      isTimedItem: props.item.is_item_timed
    };
  }

  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDragPreview: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    item: PropTypes.object.isRequired,
    moveItem: PropTypes.func.isRequired,
    dropItem: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onPositionChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    editMode: PropTypes.bool.isRequired,
  };

  formatTags(tags) {
    if (Array.isArray(tags)) {
      const maxTagsToShow = 3;
      let formattedTags;

      if (tags.length <= maxTagsToShow) {
        formattedTags = tags.map((tag) => `${tag}`).join(",");
      } else {
        const shownTags = tags
          .slice(0, maxTagsToShow)
          .map((tag) => `${tag}`)
          .join(",");
        formattedTags = `${shownTags}, ...`;
      }

      return `${formattedTags}`;
    }
  }
  getMediaElement() {
    const { item } = this.props;
    const url = "https://smallenvelop.com/demo/image-loading/spinner.gif";

    switch (item.item.type) {
      case "VIDEO":
        return (
          <video
            title={item.item.name}
            allowFullScreen
            controls
            poster={item.item.thumbnail}
            ref={(elem) => (this.preview = elem)}
            preload="metadata"
          >
            <source
              src={
                item.item.asset_url.startsWith("http")
                  ? item.item.thumbnail
                  : APP_ROOT + item.item.thumbnail || url
              }
            />
          </video>
        );
      case "IMAGE":
        return (
          <img
            src={
              item.item.asset_url.startsWith("http")
                ? item.item.thumbnail
                : APP_ROOT + item.item.thumbnail || url
            }
            ref={(elem) => (this.preview = elem)}
          />
        );
      default:
        return (
          <Icon title="No Preview available" name="eye-slash" size="1.5rem" />
        );
    }
  }

  defaultLoading() {
    return <Icon title="Loading" name="spinner" size="1.5rem" />;
  }

  durationEditable = () =>
    this.props.item.item.type === "IMAGE" ||
    this.props.item.item.type === "WEB" ||
    this.props.item.item.type === "URL" ||
    this.props.item.item.type === "PDF" ||
    this.props.item.item.type === "AQI_VEDA" ||
    this.props.item.item.type === "VIDEO" ||
    this.props.item.item.type === "ZIP";

  handleDurationChange = (event) => {
    const value = event.currentTarget.value * 1000;
    this.setState({ duration: value });
    this.props.onChange({
      id: this.props.item.id,
      duration: value,
    });
  };

  handleDurationCommit = () => {
    const trimmedDuration =
      typeof this.state.duration === "string"
        ? this.state.duration.trim()
        : this.state.duration;

    this.props.onChange({
      id: this.props.item.id,
      duration: trimmedDuration || null,
    });
  };

  // handleDurationCommit = () =>
  //   this.props.onChange({
  //     id: this.props.item.id,
  //     duration: this.state.duration && this.state.duration.trim() || null,
  //   })

  handleTimedIconChange = () => {
    const {isTimedItem} = this.state
    this.setState({isTimedItem: !isTimedItem})
    
    this.props.onChange({
      id: this.props.item.id,
      is_item_timed: !isTimedItem,
    });
  }

  handleExpireOnChange = (newValue) => {
    this.setState({ expireOn: newValue });
    this.props.onChange({
      id: this.props.item.id,
      expire_on: newValue,
    });
    {
      this.props.reportActivityStatus &&
        this.props.handleUserReport(
          `Set Expiry time as ${newValue}  for ${this.props.item.item.name} in `
        );
    }
  };

  handleStartTimeChange = (newValue) => {
    this.setState({ startTime: newValue });
    this.props.onChange({
      id: this.props.item.id,
      start_time: newValue,
    });
    {
      this.props.reportActivityStatus &&
        this.props.handleUserReport(
          `Set Start time as ${newValue}  for ${this.props.item.item.name} in `
        );
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      // enter pressed
      this.handleDurationCommit();
      event.currentTarget.blur();
    } else if (event.keyCode === 27) {
      // esc pressed
      this.setState({ duration: this.props.item.duration });
      event.currentTarget.blur();
    }
  };

  onClickItem = () => {
    this.props.selectionChange(this.props.item);
  };

  handlePositionChange = (e) =>
    this.props.onPositionChange(this.props.item.id, e.currentTarget.value);

  handleSelect = () => this.props.onSelect(this.props.item);

  editorComponent() {
    const { item } = this.props;

    return (
      <Box direction="row" className="position-editor">
        <xinput
          type="checkbox"
          onChange={this.handleSelect}
          defaultValue={false}
        />
        <input
          type="text"
          onChange={this.handlePositionChange}
          defaultValue={item.position}
        />
      </Box>
    );
  }

  render() {
    const {
      item,
      isDragging,
      connectDragSource,
      connectDragPreview,
      connectDropTarget,
      onDelete,
    } = this.props;
    const { duration, startTime, expireOn, showloading, isTimedItem} = this.state;
    const durationId = `duration-${item.id}`;
    if (!item.item) return null;

    return connectDropTarget(
      connectDragPreview(
        <div
          className={classNames("playlist-item", {
            disabled: !item.enabled,
            "is-dragging": isDragging,
          })}
          ref={(node) => (this.node = node)}
        >
          {this.props.editPostion
            ? this.editorComponent()
            : connectDragSource(
                <div className="drag-icon">
                  <Icon
                    name="bars"
                    title="Click here and drag to reorder"
                    size="1.5rem"
                  />
                </div>
              )}

          <ContentTypeIcon type={item.item.type} />
          <Link to={`/asset/${item.item.id}`} className="item-name">
            {item.item.name}
            <span className="badge-text">
              {item && item.item && item.item.campaign_details
                ? item.item.campaign_details.name
                : null}
            </span>
          </Link>
          {this.props.thumbnails == false && (
            <Link to={`/asset/${item.item.id}/`} className="item-name">
              <span
                title="Add Tags"
                className="flex hide-for-mobile"
                style={{ marginRight: "2rem", color: "black" }}
              >
                <i
                  style={{
                    fontSize: "0.8rem",
                    marginTop: "0.3rem",
                    marginRight: "0.2rem",
                  }}
                  className="fas fa-plus-circle text-primary"
                ></i>
                <small className="is-cursor ">
                  {this.formatTags(item.item.tags)}
                </small>
              </span>
            </Link>
          )}

          {this.props.adding === false && (
            <div>
              {this.props.thumbnails == true && (
                <Box
                  direction="row"
                  className={classNames(
                    "preview item-preview",
                    this.props.item.item.type.toLowerCase()
                  )}
                >
                  {showloading ? this.getMediaElement() : this.defaultLoading()}
                </Box>
              )}
            </div>
          )}

          <div
            className={classNames("duration-field input-group", {
              disabled: !this.durationEditable(),
            })}
          >
            <label htmlFor={durationId} className="input-group-label">
              <Icon title="Duration" name="clock-o" size="1.5rem" margin={5} />
            </label>

            {this.durationEditable() ? (
              <input
                id={durationId}
                className="input-group-field"
                type="text"
                value={duration / 1000 || ""}
                onBlur={this.handleDurationCommit}
                onKeyUp={this.handleKeyUp}
                onChange={this.handleDurationChange}
                title="Blank means Default"
              />
            ) : (
              <input
                type="text"
                disabled
                className="input-group-field"
                value={duration / 1000 || "default"}
              />
            )}
          </div>

          {this.props.adding === false && (
            <React.Fragment>
              <DateTimePicker
                placeholder="Start time"
                className={
                  expireOn && Moment(expireOn).isBefore(new Date())
                    ? "expire-on-input expired-item"
                    : "expire-on-input future-item"
                }
                culture="en-gb"
                step={15}
                min={new Date()}
                timeFormat="HH:mm"
                value={startTime && Moment(startTime).toDate()}
                onChange={this.handleStartTimeChange}
              />
              {this.props.isTimedPlayback &&
               <>
                {isTimedItem ? (
                <img
                  onClick={this.handleTimedIconChange}
                  style={{ margin: "0.6rem" }}
                  title="Asset is a timed asset & plays only once at start time"
                  src="http://res.cloudinary.com/dk2il6f0i/image/upload/v1706576150/niu4czwbicrmzlog2vsk.jpg"
                  width={20}
                  height={20}
                />
              ) : (
                <img
                  onClick={this.handleTimedIconChange}
                  style={{ margin: "0.6rem" }}
                  title="Asset is valid to play only after start time"
                  src="http://res.cloudinary.com/dk2il6f0i/image/upload/v1706576149/ui9bertwyys7rnxbobx5.jpg"
                  width={20}
                  height={20}
                />
              )}
              </>
              }
             
              <DateTimePicker
                placeholder="Expiry time"
                className={
                  expireOn && Moment(expireOn).isBefore(new Date())
                    ? "expire-on-input expired-item"
                    : "expire-on-input future-item"
                }
                culture="en-gb"
                step={15}
                min={new Date()}
                timeFormat="HH:mm"
                value={expireOn && Moment(expireOn).toDate()}
                onChange={this.handleExpireOnChange}
              />
            </React.Fragment>
          )}

          <Icon
            title="Delete"
            name="trash-o"
            size="1.5rem"
            onClick={() => onDelete(item)}
          />
        </div>
      )
    );
  }
}

const dragSource = {
  beginDrag(props) {
    return {
      id: props.item.id,
      index: props.index,
    };
  },
};

const dragTarget = {
  drop(props) {
    props.dropItem();
  },
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) return;

    // Determine rectangle on screen
    const hoverBoundingRect = component
      .getDecoratedComponentInstance()
      .node.getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

    props.moveItem(dragIndex, hoverIndex);

    monitor.getItem().index = hoverIndex;
  },
};

const makeTarget = DropTarget("PLAYLIST_ITEM", dragTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}));

const makeSource = DragSource(
  "PLAYLIST_ITEM",
  dragSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  })
);

export default makeTarget(makeSource(PlaylistItem));



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PlaylistItem/index.js